import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "react-toastify";

export const ProductCatalogSaveViewModal = ({
    isOpen,
    initialName = "",
    onClose,
    onSave,
}) => {
    const [name, setName] = useState(initialName);

    useEffect(() => {
        if (isOpen) setName(initialName);
    }, [initialName, isOpen]);

    if (!isOpen) return null;

    const handleSave = () => {
        const trimmed = name.trim();
        if (!trimmed) {
            toast.error("View name is required.", { position: "bottom-right" });
            return;
        }
        onSave(trimmed);
    };

    return createPortal(
        <div className="fixed inset-0 z-[70] overflow-y-auto">
            <div className="flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div
                    className="fixed inset-0 bg-gray-500 bg-opacity-75"
                    aria-hidden="true"
                    onClick={onClose}
                />
                <span className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">&#8203;</span>
                <div
                    className="inline-block w-full max-w-lg transform rounded-lg bg-white text-left align-bottom shadow-xl sm:my-8 sm:align-middle"
                    onClick={(event) => event.stopPropagation()}
                >
                    <div className="px-4 pb-4 pt-5 sm:p-6">
                        <h3 className="mb-2 text-lg font-bold">Save Current View</h3>
                        <p className="mb-4 text-sm text-gray-500">
                            Save the current column layout as a named catalog view.
                        </p>
                        <label className="flex flex-col gap-1 text-sm font-medium text-gray-900">
                            View name
                            <input
                                autoFocus
                                type="text"
                                value={name}
                                onChange={(event) => setName(event.target.value)}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") handleSave();
                                }}
                                placeholder="Wallets QC"
                                className="w-full rounded-md border border-gray-300 p-2.5 text-sm shadow-sm focus:border-primary focus:ring-primary"
                            />
                        </label>
                        <div className="flex flex-row-reverse gap-2 pt-5">
                            <button
                                type="button"
                                onClick={handleSave}
                                className="inline-flex justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                            >
                                Save
                            </button>
                            <button
                                type="button"
                                onClick={onClose}
                                className="inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};
